import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import ListViewIcon from '@material-ui/icons/ViewList';
import CardViewIcon from '@material-ui/icons/ViewStream';
import { ctx as L20NContext, Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit, change } from 'redux-form';
import IntercomManagementIconCustom from '../components/CustomIcons/IntercomManagementIconCustom.jsx';
import VirtualIntercomForm from '../components/forms/VirtualIntercom/VirtualIntercomForm.jsx';
import MDButton from '../components/MDButton/MDButton.jsx';
import OperationalView from '../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import VirtualIntercomTableView from '../components/VirtualIntercom/VirtualIntercomTableView.jsx';
import VirtualIntercomListView from '../components/VirtualIntercom/VirtualIntercomListView.jsx';
import AbilityProvider from '../permissionsUtils/AbilityProvider.js';
import * as IntercomActions from '../redux/actions/intercom.actions';
import * as TagActions from '../redux/actions/tag.actions';
import * as CredentialActions from '../redux/actions/credential.actions';
import * as ModalActions from '../redux/actions/modal.actions';
import * as UtilsActions from '../redux/actions/utils.actions';
import * as LockActions from '../redux/actions/lock.actions';
import { MATCH_TAG_MODE, PERMISSIONS, PERMISSION_ENTITIES, VIEW_MODES } from '../_config/consts';
import { getIntercomBaseUrl, localizeHelpCenterLink } from '../_config/utils.js';
import TranslatableOption from '../components/forms/Fields/TranslatableOption.jsx';
import QRCode from 'qrcode';


let filterTimeout;
@connect(state => ({ lockTags: state.tags.lock.data, form: state.form.VirtualIntercomForm, intercom: state.intercom, routing: state.router, languange: state.settings.language, viewLoading: state.utils.viewLoading, themeName: state.settings.items.theme.data.themeName }))
class VirtualIntercomManagement extends React.Component {

  constructor(props) {
    super(props);
    const cachedViewMode = localStorage.getItem('intercomViewMode');
    this.state = {
      activeTab: cachedViewMode && cachedViewMode === VIEW_MODES.CARDS ? 1 : 0,
    };
  }

  async componentWillMount() {
    const { dispatch, routing } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    this.onFetchVirtualIntercoms();
    dispatch(IntercomActions.fetchAllExtensions());
    dispatch(IntercomActions.fetchExtensionGroups());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectIntercom({}));
    dispatch(IntercomActions.setIntercomOperationalMode(false));
  }

  async onFetchVirtualIntercoms() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(IntercomActions.fetchIntercoms());
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onNewVirtualIntercomButtonClicked() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectIntercom({}));
    dispatch(initialize('VirtualIntercomForm', {}));
    dispatch(IntercomActions.setIntercomOperationalMode(true));
  }


  onCloseOperationalSection() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectIntercom({}));
    dispatch(IntercomActions.setIntercomOperationalMode(false));
  }

  onSetFilter(field, value) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.setIntercomFilter(field, value));
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      await this.onFetchVirtualIntercoms();
    }, 500);
  }

  onSearchReset() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.resetIntercomFilters());
    this.onFetchVirtualIntercoms();
  }


  onExportElements(format) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.exportIntercoms(format));
  }
  
  onIntercomsListModeChange(activeTab) {
    const { dispatch } = this.props;
    const selectedViewMode = activeTab === 0 ? VIEW_MODES.TABLE : VIEW_MODES.CARDS;
    this.setState({ activeTab });
    IntercomActions.setIntercomViewMode(selectedViewMode);
    if (activeTab === 0) {
      dispatch(IntercomActions.resetIntercomsPaginationData());
      dispatch(IntercomActions.fetchIntercoms());
    }
  }

  onFetchVirtualIntercomsOnPage(page) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.fetchIntercoms(page));
  }

  async onSelectVirtualIntercom(virtualIntercom) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.fetchAllExtensions());
      dispatch(IntercomActions.selectIntercom(virtualIntercom));
      const formData = {
        ...virtualIntercom,
        geolocation: {
          latitude: virtualIntercom.latitude,
          longitude: virtualIntercom.longitude,
          radiusMeters: virtualIntercom.radiusMeters,
        },
      };
      dispatch(initialize('VirtualIntercomForm', formData));
      dispatch(IntercomActions.setIntercomOperationalMode(true));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(IntercomActions.selectIntercom({}));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onDeleteVirtualIntercom(intercomId) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="virtualIntercomDeleteConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeleteVirtualIntercomConfirmed(intercomId),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeleteVirtualIntercomConfirmed(intercomId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(IntercomActions.deleteIntercom(intercomId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchVirtualIntercoms();
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="virtualIntercomDeleteSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="virtualIntercomDeleteError" /></h6>),
        },
      }));
    }
  }

  async onEditVirtualIntercom(intercomData) {
    const { dispatch } = this.props;
    try {
      const intercomDataParsed = {
        ...intercomData,
        smartLockIds: intercomData.smartLockIds || [],
        groupIds: intercomData.groupIds || [],
        latitude: intercomData && intercomData.geolocation && intercomData.geolocation.latitude,
        longitude: intercomData && intercomData.geolocation && intercomData.geolocation.longitude,
        radiusMeters: intercomData && intercomData.geolocation && intercomData.geolocation.radiusMeters,
        smartLocks: undefined,
        groups: undefined,
        lockTagMatchingMode: undefined,
        hyperTile: undefined,
      };
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.editIntercom(intercomData.id, intercomDataParsed));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchVirtualIntercoms();
      dispatch(IntercomActions.setIntercomOperationalMode(false));
      dispatch(IntercomActions.selectIntercom({}));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="virtualIntercomUpdatedSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="virtualIntercomActionError" /></h6>),
        },
      }));
    }
  }

  onVirtualIntercomFormSubmit(intercomData) {
    if (intercomData && intercomData.id) {
      this.onEditVirtualIntercom(intercomData);
    }
  }

  onOpenInfo() {
    const helpLink = localizeHelpCenterLink('luckey-intercom-addon');
    window.open(helpLink);
  }

  filterLockTags(value) {
    const { dispatch } = this.props;
    const includeSpecialTags = true;
    dispatch(TagActions.cancelFetchLockTagsByFilter());
    dispatch(TagActions.fetchLockTagsByFilter(value, 100, includeSpecialTags));
  }

  fetchLocksByTags(tags = [], page = 0, lockTagMatchingMode = MATCH_TAG_MODE.EVERY_TAG, append = false) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.cancelFetchIntercomLocksByTags());
    dispatch(IntercomActions.fetchIntercomLocksByTags(tags, lockTagMatchingMode, page, append));
    dispatch(change('VirtualIntercomForm', 'intercomSmartLockTags', tags));
  }

  async onOpenLockRemotely(lock) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(LockActions.onOpenFullOnlineLockRemote(lock));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="doorOpenSuccess" /></h6>),
        },
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(LockActions.selectLock({}));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="doorOpenFailed" /></h6>),
        },
      }));
    }
  }

  async onDownloadHyperTileQRCode(hyperTileId) {
    try {
      const baseUrl = getIntercomBaseUrl();
      const fullUrl = `${baseUrl}/hypertile/?hypertileId=${hyperTileId}`;
      
      // Generate QR code as data URL
      const qrDataUrl = await QRCode.toDataURL(fullUrl, {
        width: 400,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });

      // Create temporary link element to trigger download
      const link = document.createElement('a');
      link.href = qrDataUrl;
      link.download = `hypertile-qr-${hyperTileId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      const { dispatch } = this.props;
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="qrCodeGenerationError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { lockTags, intercom: { isOperationalMode, selectedIntercom, data: { pagination }, extensionGroups }, form, themeName, dispatch, viewLoading } = this.props;
    const { activeTab } = this.state;
    const numberOfVirtualIntercoms = pagination && pagination.totalElements ? pagination.totalElements : 0;
    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          onFilterChange={value => this.onSetFilter('name', _.trim(value))}
          onNewEntity={null}
          onSearchSubmit={() => this.onFetchVirtualIntercoms()}
          onSearchReset={() => this.onSearchReset()}
          searchGuestContainerStyle={{ width: 280 }}
          newEntityTitle={null}
          searchPlaceholderEntityName="search"
          newEntityIconName="icon-simple-line-icons-user-following"
          isLoading={viewLoading}
          onInfo={() => this.onOpenInfo()}
          onExportElements={format => this.onExportElements(format)}
          numberOfElements={numberOfVirtualIntercoms}
          selectableFieldName="groupId"
          selectableOptions={[
            (<Entity
              key={"intercomAnyGroupFilter"}
              componentClass={TranslatableOption}
              value={"__ANY__"}
              componentAttribute="text"
              entity={"intercomAnyGroupFilter"}
            />),
            ..._.map(_.sortBy((extensionGroups?.content || []), (group => (group.name || "").toLowerCase())), group =>
              <option value={group.id} key={group.id}>
                {group.name}
              </option>
            )
          ]}
          onSelectOption={value => this.onSetFilter('groupId', value)}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <IntercomManagementIconCustom style={{ width: 22 }} />
              <h4 style={{ marginTop: 5 }}>{numberOfVirtualIntercoms}</h4>
            </div>
          }
        />
        <div className="r-flow-on-phone" style={{ top: 140, position: 'fixed', backgroundColor: 'white' }}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, index) => this.onIntercomsListModeChange(index)}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
          >
            <Tab icon={<ListViewIcon style={{ fontSize: 30 }} />} />
            <Tab icon={<CardViewIcon style={{ fontSize: 30 }} />} />
          </Tabs>
        </div>
        {activeTab === 0 ? (
          <VirtualIntercomTableView
            onSelectVirtualIntercom={intercom => this.onSelectVirtualIntercom(intercom)}
            onRefreshVirtualIntercoms={() => this.onFetchVirtualIntercoms()}
            onFetchVirtualIntercomsOnPage={page => this.onFetchVirtualIntercomsOnPage(page)}
            onDeleteVirtualIntercom={intercomId => this.onDeleteVirtualIntercom(intercomId)}
            onDownloadHyperTileQRCode={hyperTileId => this.onDownloadHyperTileQRCode(hyperTileId)}
          />
        ) : null}
        {activeTab === 1 ? (
          <VirtualIntercomListView
            onSelectVirtualIntercom={intercom => this.onSelectVirtualIntercom(intercom)}
          />
        ) : null}
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="virtualIntercomOperationalTitle" />}
          style={{ paddingTop: 10 }}
        >
          <div style={{ padding: 10, paddingBottom: '30%' }}>
            <VirtualIntercomForm
              intercom={selectedIntercom}
              onSubmit={intercomData => this.onVirtualIntercomFormSubmit(intercomData)}
              onShowInfoModal={() => this.onOpenInfo()}
              onDeleteVirtualIntercom={intercomId => this.onDeleteVirtualIntercom(intercomId)}
              locksFilteredByTags={selectedIntercom && selectedIntercom.locksFilteredByTags ? selectedIntercom.locksFilteredByTags[0] : []}
              availableLockTags={lockTags}
              onLockInputChange={value => this.filterLockTags(value)}
              onLockTagsChange={values => this.fetchLocksByTags(values, 0, form && form.values && form.values.lockTagMatchingMode)}
              onFetchMoreLocks={page => this.fetchLocksByTags(form && form.values && form.values.intercomSmartLockTags, page, form && form.values && form.values.lockTagMatchingMode, true)}
              onLockFilterModeChange={mode => this.fetchLocksByTags(form && form.values && form.values.intercomSmartLockTags, 0, mode)}
              onOpenLockRemotely={lock => this.onOpenLockRemotely(lock)}
            />
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('VirtualIntercomForm'))}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
} 

export default VirtualIntercomManagement;
